import { ContactInfo } from './LeadParams';

export const dealerIds: { [key: string]: string } = {
  // will add a few more dealer ids
  '339415': 'MzM5NDE1',
  '374382': 'Mzc0Mzgy',
  '397783': 'Mzk3Nzgz',
  '407636': 'NDA3NjM2',
  '437196': 'NDM3MTk2',
  '439840': 'NDM5ODQw',
  '451942': 'NDUxOTQy',
};

// will use the page url once it's available
export const dealerPageUrl = 'https://www.autolist.com/dealer';
export const participantEmail = 'websaman@gmail.com';

export function appendUrlToMessage(
  contactInfo: ContactInfo,
  remoteDealerId: string,
  vin: string,
  participatingDealers: { [key: string]: string }
): ContactInfo {
  const newDealerId = participatingDealers[remoteDealerId];

  if (newDealerId && contactInfo.email === participantEmail) {
    const url = `${dealerPageUrl}?vin=${vin}&id=${newDealerId}`;
    const messageText = `Lead requests information. Click this link: ${url}`;
    const message = contactInfo.message ? `${contactInfo.message} - ${messageText}` : messageText;

    const newContactInfo = {
      ...contactInfo,
      message,
    };

    console.log('o2o: new contact ', newContactInfo);

    return newContactInfo;
  }

  return contactInfo;
}
